import { PhotosPreviewComponent } from './photos-preview.component';

export default angular
  .module('sfMobile.components.photos-preview', [])
  .component('sfPhotosPreview', PhotosPreviewComponent).name;
